import React from 'react';
import PropTypes from 'prop-types';

import AdsEnabled from './AdsEnabled';
import AtcAdSlot from '@/utilities/AtcAdSlot';

const GhostAdsContainer = React.memo(({
    slotId,
    pos,
    adSizes,
    showAd = true,
}) => showAd && adSizes?.length > 0 && (
    <div className="display-none">
        <AdsEnabled>
            <AtcAdSlot
                slotId={slotId}
                lazyLoading
                showPlaceholder={false}
                size={adSizes}
                targeting={{
                    pos,
                }}
            />
        </AdsEnabled>
    </div>
));

GhostAdsContainer.propTypes = {
    slotId: PropTypes.string,
    pos: PropTypes.string,
    adSizes: PropTypes.array,
    showAd: PropTypes.bool,
};

export default GhostAdsContainer;
